import React, { useEffect, useRef, useState } from "react";
import { Box, SvgIcon, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FulfilmentPanel from "../Panel";
import { colors } from "../../config";

interface FulfilmentSelectorProps {
  currentType: "FBA" | "FBM";
  onSelect: (type: "FBA" | "FBM") => void;
}

export default function FulfilmentSelector({
  currentType,
  onSelect,
}: FulfilmentSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (type: "FBA" | "FBM") => {
    onSelect(type);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        isOpen
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <Box
      ref={containerRef}
      position="relative"
      display="inline-block"
      width="100%"
    >
      <Box
        ref={anchorRef}
        display="flex"
        alignItems="center"
        gap="2px"
        mb={2}
        lineHeight="20px"
        sx={{ cursor: "pointer" }}
        onClick={handleClick}
      >
        <Typography fontSize={12} fontWeight={600}>
          {currentType}
        </Typography>
        <SvgIcon
          component={isOpen ? KeyboardArrowUpIcon : KeyboardArrowDownIcon}
          sx={{
            fontSize: "16px",
            color: colors.primary.main,
            "&:hover": {
              color: colors.accent.orange,
            },
          }}
        />
      </Box>
      <FulfilmentPanel
        isOpen={isOpen}
        anchorElement={anchorRef.current}
        type="fulfilment"
        currentFulfilmentType={currentType}
        onFulfilmentSelect={handleSelect}
      />
    </Box>
  );
}

